var map = {
	"./countries/en-GB-countries.json": 80584,
	"./countries/it-countries.json": 37809,
	"./de.json": 39929,
	"./en-GB.json": 43171,
	"./es.json": 18563,
	"./fr.json": 844,
	"./it.json": 20504,
	"./nl.json": 13055
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23251;